import JobApply from '../components/JobApply';
export default JobApply; 